/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import fancybox from "@fancyapps/fancybox";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./components/Header";
import Sliders from "./components/Sliders";
import TimeLine from "./components/TimeLine";
import Team from "./components/Team";
import Enquiry from "./components/Enquiry";
import SharePage from "./components/SharePage";
import Maps from "./components/Maps";
import "intl-tel-input/build/js/intlTelInput-jquery";
import "intl-tel-input/build/js/utils";
// Css
import "chosen-js";
import "chosen-js/chosen.min.css";
import "sticky-kit/dist/sticky-kit.js";
import "./external/bootstrap/bootstrap.min.css";
import "intl-tel-input/build/css/intlTelInput.min.css";
import Swiper from "swiper";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

export default new (class App {
  constructor() {
    this.setDomMap();
    this.previousScroll = 0;

    $.fn.isInViewport = function () {
      if ($(this).length) {
        const elementTop = $(this).offset().top - 800;
        const elementBottom = elementTop + $(this).outerHeight();
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      }
    };

    // dom ready shorthand
    $(() => {
      this.domReady();
    });
  }

  domReady = () => {
    this.initComponents();
    this.handleUserAgent();
    this.windowResize();
    this.bindEvents();
    this.handleSplashScreen();
    // console.log('Initializing Dom events');
    this.fancybox = $("[data-fancybox]");
    this.fancybox = $("[data-fancybox]");
    this.fancybox.fancybox({
      clickContent: false,
      backFocus: false,
      // <div class="fancybox-infobar"><span data-fancybox-index>
      // </span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>
      // <div class="fancybox-toolbar">{{buttons}}</div>

      // <div class="fancybox-buttons-wrapper">
      //       <div data-fancybox-close="" class="form-popup-close"><i class="icon__close"></i></div>
      //       <div class="carousel__buttons">{{arrows}}</div>
      //     </div>

      baseTpl: `
      <div class="fancybox-container" role="dialog" tabindex="-1">
        <div class="fancybox-bg"></div>
        <div class="fancybox-inner noel">  
          <div class= "fancybox-toolbar">
            <button data-fancybox-close class="fancybox-button fancybox-button--close" title="Close"><svg viewBox="0 0 40 40"><path d="M10,10 L30,30 M30,10 L10,30"></path></svg></button>
          </div>
          <div class="fancybox-stage"></div>
          <div class="fancybox-caption"></div>
        </div>
      </div>`,
      btnTpl: {
        close:
          '<button data-fancybox-close class="fancybox-button--close" title="{{CLOSE}}"><i class="icon__close"></i></button>',
        arrowLeft:
          '<button data-fancybox-prev class="carousel__buttons__btn-prev" title="{{PREV}}"><i class="icon__slider-prev"></i></button>',
        arrowRight:
          '<button data-fancybox-next class="carousel__buttons__btn-next" title="{{NEXT}}"><i class="icon__slider-next"></i></button>',
      },
      beforeLoad(instance, slide) {
        if (slide.contentType === 'image') {
          const c = instance.$refs.inner.find('.fancybox-buttons-wrapper');
          c.find('.carousel__buttons').css('opacity', 0);
        }
      },
      afterLoad(instance, slide) {
        instance.$refs.inner
          .find(".fancybox-buttons-wrapper")
          .css("opacity", 1);
      },
      // beforeShow(instance, slide) {
      //   instance.$refs.inner.find('.fancybox-buttons-wrapper').css('opacity', 1);
      // },
      afterShow(instance, slide) {
        if (slide.contentType === "image") {
          const w = slide.$content.width();
          const h = slide.$content.height();
          const c = instance.$refs.inner.find(".fancybox-buttons-wrapper");
          c.width(w);
          c.height(h);
        }
      },
    });

    if (this.sticky.length) {
      this.sticky.stick_in_parent({
        stick_in_parent: ".content",
      });
    }
  };

  initComponents = () => {
    new Header({
      header: this.header,
      htmlBody: this.htmlBody,
    });

    new Sliders({
      htmlBody: this.htmlBody,
    });

    new TimeLine({
      htmlBody: this.htmlBody,
    });

    new Team({
      htmlBody: this.htmlBody,
    });

    new Enquiry({
      htmlBody: this.htmlBody,
    });

    new SharePage({
      htmlBody: this.htmlBody,
    });

    if (this.mapContainer.length) {
      new Maps({
        mapContainer: this.mapContainer,
      });
    }

    if ($(window).width() < 991) {
      this.mobileMenu();
    }

    if ($("body").hasClass("property-view-page") && $(window).width() < 767) {
      let page_shares = $(
        ".property-view-page .page-share--after-banner"
      ).remove();
      $(".info-bar").after(page_shares);
    }

    if ($("body").hasClass("find-property-view-page")) {
      // var cards = $("#portfolio-grid .card");

      // cards.each(function (index) {
      //   var item = $(this);
      //   if (item.isInViewport()) {
      //     item.addClass("in-viewport");
      //     if (!item.hasClass("fade-up-card")) {
      //       item.addClass("fade-up-card");
      //     }
      //   }
      // });

      // $(window).on("scroll", function () {
      //   cards.each(function (index) {
      //     var item = $(this);
      //     if (!item.hasClass("in-viewport") && item.isInViewport()) {
      //       item.addClass("in-viewport");
      //       if (!item.hasClass("fade-up-card")) {
      //         item.addClass("fade-up-card");
      //       }
      //     }
      //   });
      // });

      if ($(".find-property-view-page").length && $(window).width() < 767) {
        $(document).ready(function () {

          // for card image 
          var touchStartX = 0;
          var touchStartY = 0;
          var touchStartTime = 0;
          var touchThresholdDistance = 10; // Adjust this value for desired touch sensitivity
          var touchThresholdDuration = 150; // Adjust this value for desired touch sensitivity

          $("#portfolio-grid .card .card-img").on("click touchstart", function (e) {
            touchStartX = e.originalEvent.touches
              ? e.originalEvent.touches[0].clientX
              : e.clientX;
            touchStartY = e.originalEvent.touches
              ? e.originalEvent.touches[0].clientY
              : e.clientY;
            touchStartTime = Date.now();
          });

          $("#portfolio-grid .card .card-img").on("click touchend", function (e) {
            var touchEndX = e.originalEvent.changedTouches
              ? e.originalEvent.changedTouches[0].clientX
              : e.clientX;
            var touchEndY = e.originalEvent.changedTouches
              ? e.originalEvent.changedTouches[0].clientY
              : e.clientY;
            var touchEndTime = Date.now();

            var touchDistanceX = Math.abs(touchEndX - touchStartX);
            var touchDistanceY = Math.abs(touchEndY - touchStartY);
            var touchDuration = touchEndTime - touchStartTime;

            if (
              touchDistanceX < touchThresholdDistance &&
              touchDistanceY < touchThresholdDistance &&
              touchDuration < touchThresholdDuration
            ) {
              e.preventDefault(); // Prevent default anchor behavior
              var aTag = $(this).find('.click-links');
              var url = aTag.attr("href"); // Get the URL from the clicked element
              console.log(url, aTag);
              window.location.href = url; // Redirect to the URL
            }
          });

          // for enquire now btn 

          $("#portfolio-grid .card .card-body .btn-group").on("click touchstart", function (e) {
            touchStartEnquireX = e.originalEvent.touches
              ? e.originalEvent.touches[0].clientX
              : e.clientX;
            touchStartEnquireY = e.originalEvent.touches
              ? e.originalEvent.touches[0].clientY
              : e.clientY;
            touchStartTimeEnquire = Date.now();
          });

          $("#portfolio-grid .card .card-body .btn-group").on("click touchend", function (e) {
            var touchEndEnquireX = e.originalEvent.changedTouches
              ? e.originalEvent.changedTouches[0].clientX
              : e.clientX;
            var touchEndEnquireY = e.originalEvent.changedTouches
              ? e.originalEvent.changedTouches[0].clientY
              : e.clientY;
            var touchEndEnquireTime = Date.now();

            var touchDistanceEnquireX = Math.abs(touchEndEnquireX - touchStartEnquireX);
            var touchDistanceEnquireY = Math.abs(touchEndEnquireY - touchStartEnquireY);
            var touchDurationEnquire = touchEndEnquireTime - touchStartEnquireTime;

            if (
              touchDistanceEnquireX < touchThresholdDistance &&
              touchDistanceEnquireY < touchThresholdDistance &&
              touchDurationEnquire < touchThresholdDuration
            ) {
              e.preventDefault(); // Prevent default anchor behavior
              var aTag2 = $(this).find('a');
              var url2 = aTag2.attr("href"); // Get the URL from the clicked element
              console.log(url2, aTag2);
              window.location.href = url2; // Redirect to the URL
            }
          });


        });
      }
    }

    if($('.formidable').length) {
      console.log('init');
      $('.formidable .g-recaptcha').each(function() {
        console.log(this)
        $(this).closest('.formidable_row').addClass('recaptcha-container');
      })
    }


    if($('footer .formidable').length) {
      setTimeout(function(){
        let arrow_svg = '<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.16026 6.81097H15.5679" stroke="#232323" stroke-width="2"></path><path d="M10.5867 12.6183L15.9119 6.80859L10.5867 0.998871" stroke="#232323" stroke-width="2"></path></svg>'

        $('footer .formidable #ff_buttons').append(arrow_svg);
        let ff_btn = $('footer .formidable #ff_buttons').remove();
        let email_parent = $('footer .formidable .emailaddress').closest('.formidable_row');
         email_parent.addClass('email-container')
        email_parent.append(ff_btn);
      }, 200)
    }
  };

  setDomMap = () => {
    this.window = $(window);
    this.htmlNbody = $("body, html");
    this.html = $("html");
    this.htmlBody = $("body");
    this.siteLoader = $(".site-loader");
    this.header = $(".header");
    this.siteBody = $(".site-body");
    this.footer = $(".footer");
    this.gotoTop = $("#gotoTop");
    this.gRecaptcha = $(".g-recaptcha");
    this.wrapper = $(".wrapper");
    this.pushDiv = this.wrapper.find(".push");
    this.mapContainer = $("#map_canvas");
    this.inputs = $("input, textarea").not('[type="checkbox"], [type="radio"]');
    this.cSelect = $(".c-select, .c-select select");
    this.sticky = $(".s-sticky");
    this.toggleBlock = $(".toogle-block__header");
    this.careerForm = $("#careerForm");
    // dev
    this.footerSticky = $(".enquiry-sticky");
    this.inputPhone = $(".ccm-input-tel");
  };

  bindEvents = () => {
    // Window Events
    this.window.resize(this.windowResize).scroll(this.windowScroll);

    // General Events
    const $container = this.wrapper;

    $container.on("click", ".disabled", () => false);

    // Specific Events
    this.gotoTop.on("click", () => {
      this.htmlNbody.animate({
        scrollTop: 0,
      });
    });

    this.cSelect.chosen({
      disable_search_threshold: 10,
    });

    AOS.init({
      // disable: () => {
      //   const maxWidth = 1060;
      //   return window.innerWidth < maxWidth;
      // },
      useClassNames: true,
      debounceDelay: 100,
      throttleDelay: 400,
      once: true,
      // anchorPlacement: 'top-bottom',
    });

    this.inputPhone.intlTelInput({
      // allowExtensions: true,
      // formatOnDisplay: true,
      // autoFormat: true,
      // autoHideDialCode: true,
      // autoPlaceholder: false,
      // defaultCountry: "auto",
      // nationalMode: false,
      // numberType: "MOBILE",
      // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
      preferredCountries: ["ae", "sa"],
      // preventInvalidNumbers: true,
      // initialCountry: "auto",
      geoIpLookup: (callback) => {
        $.get("https://ipinfo.io", () => {}, "jsonp").always((resp) => {
          const countryCode = resp && resp.country ? resp.country : "";
          callback(countryCode);
        });
      },
    });

    // $(document).ready(function() {

    //   if($('.career').length) {
    //     let numbers = "";
    //     console.log("cccs")
    //     $('.career  .button[data-src="#careerForm"]').on('click', function() {
    //       numbers = "";
    //       console.log(numbers, 'before');
    //     $("#telephone-24").on("keyup", (e) => {
    //       console.log(numbers, 'careers on key up');
    //       numbers = $("#telephone-24").val();
    //       numbers = numbers.replace(/[^\d.-]/g, "");
    //       // if (numbers.length > 15) {
    //       //   numbers = numbers.slice(0, 15);
    //       // }
    //       $("#telephone-24").val(numbers);
    //       console.log(numbers);
    //     });
    //     })
    //   } else {
    //     console.log("not cccs")
    //     let numbers = "";
    //     console.log(numbers, 'before');
    //     $("input[type='tel']").on("keyup", (e) => {
    //       console.log(numbers, 'on key up');
    //       numbers = $("input[type='tel']").val();
    //       numbers = numbers.replace(/[^\d.-]/g, "");
    //       if (numbers.length > 15) {
    //         numbers = numbers.slice(0, 15);
    //       }
    //       $("input[type='tel']").val(numbers);
    //       console.log(numbers);
    //     });
    //   }

    // })

    $("input[type='tel']").on("keyup", function (e) {
      var inputValue = $(this).val();
      var cleanedValue = inputValue.replace(/[^\d.-]/g, "");

      if (cleanedValue.length > 15) {
        cleanedValue = cleanedValue.slice(0, 15);
      }

      $(this).val(cleanedValue);
      // console.log(cleanedValue);
    });

    if ($(".toogle-block").length) {
      // Target the first div element with the class '.toogle-block'
      var firstToggleBlock = $("div.toogle-block:first");

      // Perform further actions on the 'firstToggleBlock' element
      // For example, you can add or remove classes, modify its content, etc.

      // Example: Add a class to the 'firstToggleBlock' element
      firstToggleBlock.addClass("highlighted");
    }

    this.toggleBlock.on("click", (e) => {
      if ($(e.currentTarget).hasClass("highlighted")) {
        $(e.currentTarget).removeClass("highlighted");
      }
      $(e.currentTarget).closest(".toogle-block").toggleClass("inn");
      console.log(e.currentTarget);
      $(e.currentTarget).next(".toogle-block__body ").slideToggle();
      $(e.currentTarget).closest(".toogle-block").siblings().removeClass("inn");

      const isCareer = $(e.currentTarget)
        .closest(".toogle-block")
        .hasClass("career");
      if (isCareer) {
        const title = $(e.currentTarget).find(".title").text();
        this.careerForm.find("#applicationType").text(title);
        this.careerForm.find("#application-29").val(title);
      }
    });

    $(".link-top-scroll").click(function (e) {
      e.preventDefault();
      const target = $($(this).attr("href"));
      if (target.length) {
        const scrollTo = target.offset().top;
        $("body, html").animate({ scrollTop: `${scrollTo}px` }, 800);
      }
    });

    this.inputs
      .on({
        focus: (e) => {
          const self = $(e.currentTarget);
          self.closest(".element").addClass("active");
        },
        blur: (e) => {
          const self = $(e.currentTarget);
          if (self.val() !== "") {
            self.closest(".element").addClass("active");
          } else {
            self.closest(".element").removeClass("active");
          }
        },
      })
      .trigger("blur");

    // Reload the current path when changing language instead of redirecting to landing page
    // Uncomment below and modify languages
    // $container.on('click', '.language-toggle', function(e) {
    //   e.preventDefault();
    //   const $this = $(this);
    //   const href = $this.attr('href');
    //   const isEnglish = href.indexOf('/ar') >= 0;
    //   const locArray = location.pathname.split('/');
    //   const indexOfIndex = locArray.indexOf('index.php');
    //   const isDev = indexOfIndex >= 0;
    //   const index = isDev ? indexOfIndex + 1 : 1;
    //   if(!isEnglish) {
    //     locArray = locArray.filter(item => item !== 'ar')
    //   }
    //   locArray.splice(index, 0, isEnglish ? 'ar' : '');
    //   const newHref = locArray.join('/').replace('//', '/');
    //   location.href = newHref;
    // });

    // Uncomment below if you need to add google captcha (also in includes/script.php)
    // => Make sure the SITEKEY is changed below
    // this.gRecaptcha.each((index, el) => {
    //   grecaptcha.render(el, {'sitekey' : '6LeB3QwUAAAAADQMo87RIMbq0ZnUbPShlwCPZDTv'});
    // });
  };

  mobileMenu = () => {
    console.log("ahIIII");

    if ($(".header__site-nav--mobile .header__site-nav--list-item.has-dropdown--projects").length) {
      $(document).ready(function () {
        $(".header__site-nav--mobile-dropdown").hide();
        $(".header__site-nav__dropdown--list-container").hide();
        // Add plus button to the current list item
        $(".header__site-nav--list-item.has-dropdown--projects").append(
          '<div class="plus-button"></div>'
        );

        $(
          ".header__site-nav--mobile-dropdown .header__site-nav__dropdown--list-label"
        ).append('<div class="plus-button"></div>');

        // Handle click event on the plus button
        $(
          ".header__site-nav--list-item.has-dropdown--projects >  .plus-button"
        ).click(function () {
          // Toggle the visibility of the mobile dropdown
          $(".header__site-nav--mobile-dropdown").slideToggle();
          $(this).toggleClass("active");
        });

        // Handle click event on each dropdown list label
        $(".header__site-nav__dropdown--list-label").click(function () {
          // Find the corresponding list container
          var container = $(this).next(
            ".header__site-nav__dropdown--list-container"
          );

          // Toggle the visibility of the list container
          container.slideToggle();

          $(this).find(".plus-button").toggleClass("active");
        });

        $(".mobile-menu").click(function () {
          if ($(".plus-button").hasClass("active")) {
            $(".header__site-nav--mobile-dropdown").slideUp();
            $(".header__site-nav__dropdown--list-container").slideUp();
            $(".plus-button").removeClass("active");
          }
        });
      });
    }
  };

  windowResize = () => {
    this.screenWidth = this.window.width();
    this.screenHeight = this.window.height();

    // calculate footer height and assign it to wrapper and push/footer div
    if (this.pushDiv.length) {
      setTimeout(function() {
        this.footerHeight = this.footer.outerHeight();
        this.wrapper.css("margin-bottom", -this.footerHeight);
        this.pushDiv.height(this.footerHeight);
      }, 600)
      
    }
    // fancybox nav fix
    // if ($('.fancybox-buttons-wrapper').length && $('.fancybox-content').length) {
    //   setTimeout(() => {
    //     $('.fancybox-buttons-wrapper').width($('.fancybox-content').width());
    //     $('.fancybox-buttons-wrapper').height($('.fancybox-content').height());
    //   }, 100);
    // }
  };

  windowScroll = () => {
    const topOffset = this.window.scrollTop();

    this.header.toggleClass("top", topOffset > 100);
    this.header.toggleClass("sticky", topOffset > 350);
    if (topOffset > this.previousScroll || topOffset < 250) {
      this.header.removeClass("sticky");
    } else if (topOffset < this.previousScroll) {
      this.header.addClass("sticky");
      // Additional checking so the header will not flicker
      if (topOffset > 250) {
        this.header.addClass("sticky");
      } else {
        this.header.removeClass("sticky");
      }
    }

    this.previousScroll = topOffset;
    this.gotoTop.toggleClass(
      "active",
      this.window.scrollTop() > this.screenHeight / 2
    );

    // footer_sticky
    this.footerSticky.toggleClass(
      "active",
      this.window.scrollTop() > this.screenHeight / 2
    );
  };

  handleSplashScreen() {
    this.htmlBody.find(".logo-middle").fadeIn(500);
    this.siteLoader.delay(1500).fadeOut(500);
  }

  handleUserAgent = () => {
    // detect mobile platform
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      this.htmlBody.addClass("ios-device");
    }
    if (navigator.userAgent.match(/Android/i)) {
      this.htmlBody.addClass("android-device");
    }

    // detect desktop platform
    if (navigator.appVersion.indexOf("Win") !== -1) {
      this.htmlBody.addClass("win-os");
    }
    if (navigator.appVersion.indexOf("Mac") !== -1) {
      this.htmlBody.addClass("mac-os");
    }

    // detect IE 10 and 11P
    if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > 0
    ) {
      this.html.addClass("ie10");
    }

    // detect IE Edge
    if (/Edge\/\d./i.test(navigator.userAgent)) {
      this.html.addClass("ieEdge");
    }

    // Specifically for IE8 (for replacing svg with png images)
    if (this.html.hasClass("ie8")) {
      const imgPath = "/themes/theedge/images/";
      $("header .logo a img,.loading-screen img").attr(
        "src",
        `${imgPath}logo.png`
      );
    }

    // show ie overlay popup for incompatible browser
    if (this.html.hasClass("ie9")) {
      const message = $(
        '<div class="no-support"> You are using outdated browser. Please <a href="https://browsehappy.com/" target="_blank">update</a> your browser or <a href="https://browsehappy.com/" target="_blank">install</a> modern browser like Google Chrome or Firefox.<div>'
      );
      this.htmlBody.prepend(message);
    }
  };
})();

// const swiper = new Swiper('.project__payment-plans__list', {
//   loop: false,
//   slidesPerView: 'auto',
//   // Navigation arrows
//   navigation: {
//     nextEl: '.section__payment-plans .carousel__buttons__btn-next--external',
//     prevEl: '.section__payment-plans .carousel__buttons__btn-prev--external',
//   },
// });
